import { render } from "./SkillComponentJa.vue?vue&type=template&id=d95882bc&scoped=true"
import script from "./SkillComponentJa.vue?vue&type=script&lang=js"
export * from "./SkillComponentJa.vue?vue&type=script&lang=js"

import "./SkillComponentJa.vue?vue&type=style&index=0&id=d95882bc&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d95882bc"]])

export default __exports__